import { colors } from 'ui/theme/colors';
import { SvgIcon, SvgIconProps } from 'ui/icons/SvgIcon';

export const EmptyStateInApp = ({ height = 104, width = 102, ...props }: SvgIconProps) => (
  <SvgIcon
    height={height}
    width={width}
    viewBox="0 0 102 104"
    data-test="in-app-empty-state"
    {...props}
  >
    <path
      d="M0.699219 51.0659C0.699219 64.4769 6.1251 77.3385 15.7832 86.8215C25.4413 96.3044 38.5406 101.632 52.1992 101.632C65.8579 101.632 78.9571 96.3044 88.6152 86.8215C98.2733 77.3385 103.699 64.4769 103.699 51.0659C103.699 37.655 98.2733 24.7934 88.6152 15.3104C78.9571 5.82747 65.8579 0.5 52.1992 0.5C38.5406 0.5 25.4413 5.82747 15.7832 15.3104C6.1251 24.7934 0.699219 37.655 0.699219 51.0659Z"
      fill={colors.grey5}
    />
    <path
      d="M28.9102 91.3409C28.9102 91.9786 31.364 92.5902 35.7319 93.0411C40.0997 93.492 46.0238 93.7453 52.2009 93.7453C58.378 93.7453 64.3021 93.492 68.67 93.0411C73.0379 92.5902 75.4917 91.9786 75.4917 91.3409C75.4917 90.7032 73.0379 90.0917 68.67 89.6408C64.3021 89.1898 58.378 88.9365 52.2009 88.9365C46.0238 88.9365 40.0997 89.1898 35.7319 89.6408C31.364 90.0917 28.9102 90.7032 28.9102 91.3409Z"
      fill={colors.grey15}
    />
    <path
      d="86 86.652C51.3969 86.6559 50.6325 86.4032 50.0094 85.9337C49.3864 85.4642 48.9401 84.8046 48.7408 84.0586C48.5415 83.3127 48.6006 82.5229 48.9087 81.8136C49.2168 81.1043 49.7565 80.5157 50.4427 80.1406V8.86217C49.7596 8.48459 49.2232 7.89543 48.9174 7.18678C48.6115 6.47813 48.5534 5.68994 48.7522 4.94544C48.951 4.20094 49.3954 3.5421 50.016 3.0719C50.6366 2.60171 51.3984 2.34668 52.1822 2.34668C52.9661 2.34668 53.7279 2.60171 54.3485 3.0719C54.9691 3.5421 55.4135 4.20094 55.6123 4.94544C55.811 5.68994 55.753 6.47813 55.4471 7.18678C55.1412 7.89543 54.6048 8.48459 53.9218 8.86217V80.1406C54.608 80.5157 55.1476 81.1043 55.4557 81.8136C55.7639 82.5229 55.8229 83.3127 55.6237 84.0586C55.4244 84.8046 54.9781 85.4642 54.355 85.9337C53.732 86.4032 52.9676 86.6559 52.1822 86.652Z"
      fill={colors.white}
    />
    <path
      d="M74.8032 83.473C74.8032 85.1121 74.1401 86.6841 72.9597 87.8431C71.7792 89.0022 70.1782 89.6533 68.5088 89.6533H35.8882C34.2188 89.6533 32.6178 89.0022 31.4373 87.8431C30.2569 86.6841 29.5938 85.1121 29.5938 83.473V14.7809C29.5938 13.1417 30.2569 11.5698 31.4373 10.4107C32.6178 9.25172 34.2188 8.60059 35.8882 8.60059H68.5119C70.1813 8.60059 71.7823 9.25172 72.9627 10.4107C74.1432 11.5698 74.8063 13.1417 74.8063 14.7809L74.8032 83.473Z"
      fill="white"
      stroke={colors.purple90}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.5273 20.1802H70.8709V77.1096H33.5273V20.1802Z"
      fill={colors.cyan10}
      stroke={colors.purple90}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M50.2344 14.3916L61.0443 14.3906"
      stroke={colors.purple90}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.3406 13.4243C44.0916 13.4402 43.8581 13.5485 43.6874 13.7273C43.5168 13.906 43.4219 14.1418 43.4219 14.3868C43.4219 14.6318 43.5168 14.8676 43.6874 15.0464C43.8581 15.2251 44.0916 15.3334 44.3406 15.3493C44.5896 15.3334 44.8231 15.2251 44.9937 15.0464C45.1643 14.8676 45.2593 14.6318 45.2593 14.3868C45.2593 14.1418 45.1643 13.906 44.9937 13.7273C44.8231 13.5485 44.5896 13.4402 44.3406 13.4243Z"
      fill={colors.purple100}
    />
    <path
      d="M33.5273 20.1802H51.6407V77.1096H33.5273V20.1802Z"
      fill="white"
      stroke={colors.purple100}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M36.8281 53.5283H67.535V72.662H36.8281V53.5283Z"
      fill={colors.grey5}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.6406 53.5283H67.535V72.662H51.6406V53.5283Z"
      fill={colors.white}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.6406 65.3777H64.9523"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.6406 60.5618H64.9523"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M36.9023 26.7437H67.5372V50.1219H36.9023V26.7437Z" fill="white" />
    <path
      d="M54.3399 49.5953L55.8885 43.2232C56.164 42.8447 56.5274 42.5362 56.9487 42.3234C57.3699 42.1105 57.8369 41.9995 58.3106 41.9995C58.7844 41.9995 59.2513 42.1105 59.6726 42.3234C60.0939 42.5362 60.4573 42.8447 60.7327 43.2232L65.751 50.1199"
      fill={colors.purple10}
    />
    <path
      d="M54.3399 49.5953L55.8885 43.2232C56.164 42.8447 56.5274 42.5362 56.9487 42.3234C57.3699 42.1105 57.8369 41.9995 58.3106 41.9995C58.7844 41.9995 59.2513 42.1105 59.6726 42.3234C60.0939 42.5362 60.4573 42.8447 60.7327 43.2232L65.751 50.1199"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.9414 50.1197L48.4889 41.5477C48.7663 41.1849 49.1259 40.8905 49.5392 40.6877C49.9525 40.485 50.4082 40.3794 50.8702 40.3794C51.3322 40.3794 51.7879 40.485 52.2012 40.6877C52.6145 40.8905 52.9741 41.1849 53.2515 41.5477L59.799 50.1197H41.9414Z"
      fill={colors.purple10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M36.9023 26.7437H51.6428V50.1219H36.9023V26.7437Z" fill={colors.grey5} />
    <path
      d="M36.9023 26.7437H67.5372V50.1219H36.9023V26.7437Z"
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.8477 34.0497C53.8477 34.8249 54.1613 35.5683 54.7195 36.1164C55.2778 36.6646 56.0349 36.9725 56.8244 36.9725C57.6139 36.9725 58.3711 36.6646 58.9293 36.1164C59.4876 35.5683 59.8012 34.8249 59.8012 34.0497C59.8012 33.2746 59.4876 32.5311 58.9293 31.983C58.3711 31.4349 57.6139 31.127 56.8244 31.127C56.0349 31.127 55.2778 31.4349 54.7195 31.983C54.1613 32.5311 53.8477 33.2746 53.8477 34.0497Z"
      fill={colors.green10}
      stroke={colors.purple100}
      strokeWidth="1.28"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.1822 86.652C51.3969 86.6559 50.6325 86.4032 50.0094 85.9337C49.3864 85.4642 48.9401 84.8046 48.7408 84.0586C48.5415 83.3127 48.6006 82.5229 48.9087 81.8136C49.2168 81.1043 49.7565 80.5157 50.4427 80.1406V8.86217C49.7596 8.4846 49.2232 7.89543 48.9174 7.18678C48.6115 6.47813 48.5534 5.68994 48.7522 4.94544C48.951 4.20094 49.3954 3.5421 50.016 3.0719C50.6366 2.60171 51.3984 2.34668 52.1822 2.34668C52.9661 2.34668 53.7279 2.60171 54.3485 3.0719C54.9691 3.5421 55.4135 4.20094 55.6123 4.94544C55.811 5.68994 55.753 6.47813 55.4471 7.18678C55.1412 7.89543 54.6048 8.4846 53.9218 8.86217V80.1406C54.608 80.5157 55.1476 81.1043 55.4557 81.8136C55.7639 82.5229 55.8229 83.3127 55.6237 84.0586C55.4244 84.8046 54.9781 85.4642 54.355 85.9337C53.732 86.4032 52.9676 86.6559 52.1822 86.652V86.652Z"
      fill="white"
    />
    <path
      d="M52.1822 2.99564C52.8561 2.98927 53.511 3.21487 54.0332 3.63325C54.5554 4.05162 54.9118 4.63636 55.0406 5.28591C55.1695 5.93546 55.0625 6.60879 54.7384 7.18898C54.4142 7.76917 53.8934 8.21957 53.2663 8.46196V80.5397C53.8881 80.7867 54.403 81.2384 54.7228 81.8173C55.0427 82.3962 55.1475 83.0663 55.0194 83.7128C54.8912 84.3593 54.5381 84.9418 54.0205 85.3607C53.5028 85.7796 52.8529 86.0086 52.1822 86.0086C51.5114 86.0086 50.8615 85.7796 50.3439 85.3607C49.8263 84.9418 49.4731 84.3593 49.345 83.7128C49.2168 83.0663 49.3217 82.3962 49.6415 81.8173C49.9613 81.2384 50.4763 80.7867 51.0981 80.5397V8.46196C50.471 8.21957 49.9501 7.76917 49.626 7.18898C49.3018 6.60879 49.1949 5.93546 49.3237 5.28591C49.4525 4.63636 49.809 4.05162 50.3312 3.63325C50.8533 3.21487 51.5082 2.98927 52.1822 2.99564ZM52.1822 1.70854C51.2854 1.70462 50.4109 1.98299 49.6871 2.50282C48.9633 3.02265 48.4282 3.75657 48.1603 4.59691C47.8924 5.43724 47.9058 6.33975 48.1986 7.17203C48.4915 8.00431 49.0482 8.72254 49.7872 9.22135V79.7816C49.0519 80.2825 48.4986 81.001 48.2082 81.8323C47.9178 82.6635 47.9053 83.5641 48.1726 84.4029C48.4399 85.2416 48.973 85.9745 49.6943 86.4949C50.4155 87.0154 51.2871 87.296 52.1822 87.296C53.0772 87.296 53.9489 87.0154 54.6701 86.4949C55.3913 85.9745 55.9244 85.2416 56.1917 84.4029C56.459 83.5641 56.4466 82.6635 56.1561 81.8323C55.8657 81.001 55.3125 80.2825 54.5771 79.7816V9.22135C55.3161 8.72254 55.8729 8.00431 56.1657 7.17203C56.4585 6.33975 56.472 5.43724 56.2041 4.59691C55.9362 3.75657 55.4011 3.02265 54.6772 2.50282C53.9534 1.98299 53.079 1.70462 52.1822 1.70854Z"
      fill={colors.purple100}
    />
  </SvgIcon>
);
